import React, { Component } from 'react';

import getMyMap, {createResidentialAreasMassLayer, createAreasLayer} from './leaflet_map';

import LegendResidentialArea from '../b-LeafletMap/Legend/LegendResidentialArea';
import LegendClusterArea from '../b-LeafletMap/Legend/LegendClusterArea';

class LeafletMapPlaces extends React.Component {

  componentDidMount() {
    // --- init map
    var mymap = this.mymap = getMyMap(this.props.id, true, 0.2);

    // --- create layers
    var residential_areas_layer = this.residential_areas_layer = createResidentialAreasMassLayer(mymap, this.props.residential_areas);
    var areas_layer = this.areas_layer = createAreasLayer(mymap, this.props.areas);

    // --- center the map
    mymap.fitBounds(residential_areas_layer.getBounds());
  }

  componentDidUpdate() {
    // --- update areas
    this.mymap.removeLayer(this.areas_layer);
    this.areas_layer = createAreasLayer(this.mymap, this.props.areas);

    // --- center the map
    this.mymap.fitBounds(this.residential_areas_layer.getBounds())
  }

  render() {
    return(
      <div className="row align-items-end">
        <div className="col-2">
             <LegendResidentialArea grey={true}/>
             <LegendClusterArea grey={true}/>
        </div>
        <div className="col-10">
          <div style={{height: "500px"}} id={this.props.id}></div>
        </div>
      </div>
    )
  }
}

export default LeafletMapPlaces;
